import { resetWebGPUState } from '../rendering/webgpuRenderer.js';

export interface ViewportCanvasController {
  getCanvas(needType: string): HTMLCanvasElement;
  present(): void;
}

export function createViewportCanvasController(): ViewportCanvasController {
  let canvasContextType: string | null = null;

  return {
    getCanvas(needType: string): HTMLCanvasElement {
      const wrap = document.getElementById('viewport-canvas-wrap')!;
      let canvas = document.getElementById('viewport-canvas') as HTMLCanvasElement;
      if (canvasContextType && canvasContextType !== needType) {
        const next = document.createElement('canvas');
        next.id = 'viewport-canvas';
        next.className = canvas.className;
        wrap.replaceChild(next, canvas);
        wrap.classList.remove('viewport-canvas-visible');
        canvas = next;
        canvasContextType = null;
        resetWebGPUState();
      }
      canvasContextType = needType;
      return canvas;
    },
    present(): void {
      document.getElementById('viewport-canvas-wrap')?.classList.add('viewport-canvas-visible');
    },
  };
}
